import { Confetti } from "@phosphor-icons/react";

const MINT_WASH = "rgba(0, 212, 146, 0.06)";
const EMERALD_GLOW =
  "radial-gradient(44% 100% at 50% 0%, rgba(0, 188, 125, 0.20) 0%, rgba(0, 188, 125, 0.10) 49.29%, rgba(0, 188, 125, 0) 100%)";
const EMERALD_GLOW_BURN =
  "radial-gradient(53.57% 56.87% at 50% 0%, rgba(0, 188, 125, 0.06) 0%, rgba(0, 188, 125, 0.03) 49.29%, rgba(0, 188, 125, 0) 100%)";
const EMERALD_ICON = "#00bc7d";
const EMERALD_TEXT = "#007a55";

export interface GiftCardSuccessStripProps {
  message: string;
  subtext?: string;
}

const GiftCardSuccessStrip = ({
  message,
  subtext,
}: GiftCardSuccessStripProps) => {
  return (
    <div
      className="ui-flex ui-w-full ui-flex-col ui-items-start ui-justify-end ui-self-stretch ui-px-5 ui-py-3"
      style={{
        background: `linear-gradient(0deg, ${MINT_WASH} 0%, ${MINT_WASH} 100%), ${EMERALD_GLOW_BURN}, ${EMERALD_GLOW}`,
        backgroundBlendMode: "normal, color-burn, normal",
      }}
    >
      <div className="ui-relative ui-flex ui-w-full ui-items-center ui-gap-2">
        <span className="ui-flex ui-size-6 ui-shrink-0 ui-items-center ui-justify-center">
          <Confetti
            size={22}
            weight="duotone"
            style={{ color: EMERALD_ICON }}
          />
        </span>
        <div className="ui-flex ui-min-w-0 ui-flex-1 ui-flex-col">
          <p
            className="ui-w-full ui-break-words ui-text-text-xs-semibold"
            style={{ color: EMERALD_TEXT }}
          >
            {message}
          </p>
          {Boolean(subtext) && (
            <p className="ui-w-full ui-break-words ui-text-text-xs-semibold ui-opacity-60">
              {subtext}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default GiftCardSuccessStrip;
